// Rental Sale logic
export const getSaleStatusText = (status) => {
  switch (status) {
    case "1":
      return "Requsted";
    case "2":
      return "Rejected";
    case "3":
      return "Accpted";
    case "4":
      return "Paid";
    case "5":
      return "out for delivery";
    case "6":
      return "Item Deliverd";
    case "7":
      return "Completed";
    default:
      return "Unknown";
  }
};

// Rental status logic
export const getRentalStatusText = (status) => {
  switch (status) {
    case "1":
      return "Requested";
    case "2":
      return "Rejected";
    case "3":
      return "Accepted";
    case "4":
      return "Amount Paid";
    case "5":
      return "In Progress";
    case "6":
      return "Service Delivered";
    case "7":
      return "Completed";
    default:
      return "Unknown";
  }
};

// Auction Bid status logic
export const getAuctionBidStatusText = (status) => {
  switch (status) {
    case "1":
      return "Bid";
    case "2":
      return "Won";
    case "3":
      return "Amount Paid";
    case "4":
      return "Out for Delivery";
    case "5":
      return "Item Delivered";
    case "6":
      return "Completed";
    default:
      return "Unknown";
  }
};

// BXP status logic
export const getBxpStatusText = (status) => {
  switch (status) {
    case "0":
      return "Pending Payment";
    case "1":
      return "Requested";
    case "2":
      return "Rejected";
    case "3":
      return "Accepted";
    case "9":
      return "Moved to Project";
    default:
      return "Unknown";
  }
};
